module.exports = __webpack_public_path__ + "79b7ac1d267bb83df3bd788c4897f58c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/SpotinTechnical_desktop.svg
// module id = 162
// module chunks = 0